import { createSlice } from "@reduxjs/toolkit";

// Frase de "Cargando..." del loop agéntico del bot. El backend la
// manda como activity de tipo "event" (name: "luca/progress") en cada
// paso del loop; el store middleware de App.tsx la guarda aquí y
// LoadingPhraseIndicator la muestra junto al typing indicator.
const initialState = {
    value: ""
}

const loadingPhraseSlice = createSlice({
    name: 'loadingPhrase',
    initialState,
    reducers: {
        setLoadingPhrase: (state, action) => {
            state.value = action.payload
        },
        clearLoadingPhrase: (state) => {
            state.value = ""
        }
    }
})

export const { setLoadingPhrase, clearLoadingPhrase } = loadingPhraseSlice.actions;
export default loadingPhraseSlice.reducer
